import React, { useImperativeHandle, useRef, forwardRef } from 'react';
import $ from "jquery";
import raf from 'raf';

interface Props {
    onSubscribe: () => void;
};

interface RefProps {
    show: () => void;
    hide: () => void;
};

const Menu = forwardRef<RefProps, Props>((props, ref) => {

    const { onSubscribe } = props;
    const nodeRef: any = useRef(null);

    const show = () => {
	const node = $(nodeRef?.current);
	const body = $('body');

	node.show();
	body.addClass('noScroll');
	raf(() => {
	    node.addClass('show');
	});
    };

    const hide = () => {
	const node = $(nodeRef?.current);
	const body = $('body');

	node.removeClass('show');
	body.removeClass('noScroll');

	window.setTimeout(() => {
	    node.hide();
	}, 500);
    };

    useImperativeHandle(ref, () => ({
	show,
	hide
    }));

    return (
	<div ref={nodeRef} className="menuWrapper">
	    <div className="dimmer" onClick={hide} />
	    <div className="menu">
		<div className="top">
		    <div className="close" onClick={hide} />
		</div>

		<div className="links">
		    <a target="_blank" href="https://download.anytype.io/">Download</a>
		    <span onClick={onSubscribe}>Subscribe to updates</span>
		    <a target="_blank" href="https://anytype.io/contributors">Join to contribute</a>
		    <a target="_blank" href="https://gallery.any.coop/">Browse Gallery</a>
		    <a target="_blank" href="https://anytype.io/faq" className="s50">FAQ</a>
		    <a target="_blank" href="https://community.anytype.io/" className="s50">Community</a>
		    <a target="_blank" href="https://blog.anytype.io/" className="s50">Blog</a>
		    <a target="_blank" href="https://doc.anytype.io/anytype-docs/" className="s50">Docs</a>
		    <a target="_blank" href="https://anytype.io/reviews" className="s50">Testimonials</a>
		    <a target="_blank" href="https://anytype.io/contact" className="s50">Contact</a>
		</div>

		<div className="social">
		    <a target="_blank" href="https://t.me/anytype"><div className="icon telegram" /></a>
		    <a target="_blank" href="https://github.com/anyproto"><div className="icon github" /></a>
		    <a target="_blank" href="https://x.com/AnytypeLabs"><div className="icon twitter" /></a>
		</div>
	    </div>
	</div>
    );
});

export default Menu;